import { LoadingDark } from '@musinsa/mds';
import styled, { CSSProperties } from 'styled-components';

type Props = Partial<{
  size: 'size24x24' | 'size12x12' | null | undefined;
  cssproperties: CSSProperties;
}>;

export const Loading = ({ size, cssproperties }: Props) => (
  <S.Wrap $cssproperties={cssproperties}>
    <LoadingDark size={size || 'size24x24'} />
  </S.Wrap>
);

const S = {
  Wrap: styled.div<{ $cssproperties: Props['cssproperties'] }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${({ $cssproperties }) => $cssproperties && { ...$cssproperties }}
  `,
};
